import { PromoCodeCreatedBy, PromoCodeTag } from '../../../../../../services/exports/Constants';

export default {
  title: 'Códigos promocionais',
  tabs: {
    active: 'Ativo',
    expired: 'Expirado',
    email_sign_up: 'Inscrição por e-mail promocional',
  },
  show_master_promo_code: 'Mostrar código promocional principal aos clientes',
  send_rejected_order_apologies_promo_code:
    'Enviar código promocional aos clientes quando a encomenda é rejeitada manualmente',
  filters: {
    tag: {
      placeholder: 'Etiqueta',
      options: {
        [PromoCodeTag.Master]: 'Principal',
        [PromoCodeTag.Campaign]: 'Campanha',
        [PromoCodeTag.OneTime]: 'Uma utilização',
      },
    },
    code: {
      placeholder: 'Código',
    },
    campaign: {
      placeholder: 'Campanha',
    },
    created_by: {
      placeholder: 'Criado por',
      options: {
        [PromoCodeCreatedBy.User]: 'Utilizador',
        [PromoCodeCreatedBy.System]: 'Sistema',
      },
    },
  },
  fields: {
    code: 'Código',
    tag: 'Etiqueta',
    type: 'Tipo',
    discount_type: 'Tipo de desconto',
    discount: 'Desconto',
    usage_threshold: 'Limite de utilização',
    quantity: 'Quantidade',
    expires_at: 'Expira',
    level: 'Nível',
    max_discount: 'Desconto máximo',
    created_by: 'Criado por',
    image: 'Imagem',
  },
  tags: {
    [PromoCodeTag.Master]: 'Principal',
    [PromoCodeTag.Campaign]: 'Campanha',
    [PromoCodeTag.OneTime]: 'Uma utilização',
  },
  types: {
    single_use: 'Uso único',
    multi_use: 'Uso múltiplo',
    unknown: 'Desconhecido',
  },
  discount_types: {
    fixed_amount: 'Valor fixo',
    percentage: 'Percentagem',
    unknown: 'Desconhecido',
  },
  created_by: {
    [PromoCodeCreatedBy.User]: 'Utilizador',
    [PromoCodeCreatedBy.System]: 'Sistema',
  },
  labels: {
    discount: 'Desconto',
    usage_threshold: 'Limite de utilização',
    company: 'Empresa',
    restaurant: 'Restaurante',
    restaurant_group: 'Marca',
  },
  buttons: {
    add: 'Adicionar',
    edit: 'Editar',
    delete: 'Eliminar',
    restore: 'Restaurar',
    add_promo_code: 'Adicionar código promocional',
    images: 'Gerir imagem',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar dados',
    failed_to_save_settings: 'Falha ao guardar as alterações',
    failed_to_delete_promo_code: 'Falha ao eliminar o código promocional',
    failed_to_restore_promo_code: 'Falha ao restaurar o código promocional',
    promo_code_got_deleted: 'Código promocional eliminado',
    promo_code_got_restored: 'Código promocional restaurado',
  },
  delete_confirmation: {
    title: 'Eliminar código promocional?',
    buttons: {
      yes: 'Sim',
      no: 'Não',
    },
  },
  restore_confirmation: {
    title: 'Restaurar código promocional?',
    buttons: {
      yes: 'Sim',
      no: 'Não',
    },
  },
};
